import React from "react"

import type {
    PublicTeamMemberFieldsFragment,
    TeamMemberFieldsFragment,
} from "~graphql/generated/graphql"
import ImageCard from "~components/shared/todo-lib-react-components/image-card/image-card"
import COPY from "~config/copy-constants"
interface Props {
    readonly guide: TeamMemberFieldsFragment | PublicTeamMemberFieldsFragment
}

export default function GuideImageCard({ guide }: Props) {
    return (
        <ImageCard
            title={guide.name}
            isDisabled
            headerImageSrc={guide.user?.avatar_url ?? undefined}
            headerImageRatio={1}
        >
            {COPY.GUIDE}
        </ImageCard>
    )
}
